import "./Text.css";

export default function RichText({fldName, form, fldDef, opts}){
    opts = opts || {};
    const {...rest} = form.register(fldName, {required: 1});

    // const textarea = useRef();
    return <>
        <textarea
            // taid={taId}
            className="form-control"
            type="text"
            name={fldName}
            {...rest}
        />
        {form.formState.errors[fldName] && <p className="fld-error">{form.formState.errors[fldName].message}</p>}
    </>;
}